import { LearningModuleWithProgress } from '~/utils/learningModules/bindProgressToLearningModule';

const isLearningModuleCompleted = (item: LearningModuleWithProgress) =>
  (item?.__typename === 'Video' && item?.completed) ||
  (item?.__typename === 'CaseStudy' && item?.passed);

export default isLearningModuleCompleted;
